import { environment } from 'src/environments/environment';

export type AssetContext = 'placement' | 'diagnostic';

export function diagnosticImageUrl(imageId: string, extension: string = 'jpg'): string {
	const id = imageId.toLowerCase().trim().replace(/ +/g, '_');
	const normalized = id.startsWith('image_') ? id : `image_${id}`;
	return `https://storage.googleapis.com/${environment.BUCKETS.CONTENT_BUCKET}/images/${normalized}.${extension}`;
}

export function defaultImageUrl(): string {
	return `https://storage.googleapis.com/${environment.BUCKETS.CONTENT_BUCKET}/images/image_default.jpg`;
}

export function diagnosticAudioUrl(audioId: string): string {
	return `https://storage.googleapis.com/${environment.BUCKETS.CONTENT_BUCKET}/audios-diagnostic/${audioId}.mp3`;
}

export function placementImageUrl(imageId: string, extension: string = 'jpg'): string {
	const id = imageId.toLowerCase().trim().replace(/ +/g, '_');
	const normalized = id.startsWith('image_') ? id : `image_${id}`;
	return `https://storage.googleapis.com/${environment.BUCKETS.CONTENT_BUCKET}/images-placement/${normalized}.${extension}`;
}

export function placementAudioUrl(audioId: string): string {
	return `https://storage.googleapis.com/${environment.BUCKETS.CONTENT_BUCKET}/audios-placement/${audioId}.mp3`;
}

export function imageUrlForContext(context: AssetContext, imageId: string, extension: string = 'jpg'): string {
	return context === 'diagnostic' ? diagnosticImageUrl(imageId, extension) : placementImageUrl(imageId, extension);
}

export function audioUrlForContext(context: AssetContext, audioId: string): string {
	return context === 'diagnostic' ? diagnosticAudioUrl(audioId) : placementAudioUrl(audioId);
}
